import { render, staticRenderFns } from "./ReprintPayment.vue?vue&type=template&id=133de820&scoped=true"
import script from "./ReprintPayment.vue?vue&type=script&lang=js"
export * from "./ReprintPayment.vue?vue&type=script&lang=js"
import style0 from "./ReprintPayment.vue?vue&type=style&index=0&id=133de820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133de820",
  null
  
)

export default component.exports